import { motion } from "framer-motion";

const Horseshoe = () => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        className="shrink-0 text-[#D4AF37]"
        aria-hidden="true"
    >
        <path
            d="M6 21v-7a6 6 0 0 1 12 0v7"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
        />
        <path
            d="M6 11.5V9M18 11.5V9M8.6 6.2 7.4 4.2M15.4 6.2l1.2-2"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
        />
    </svg>
);

const Sequence = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {Array.from({ length: 4 }).map((_, i) => (
            <span key={i} className="flex items-center">
                <span className="mx-7 font-mono-mm text-lg uppercase tracking-[0.35em] text-[#F5F5F0]/85 md:mx-11 md:text-2xl">
                    Mane Miles
                </span>
                <Horseshoe />
                <span className="mx-7 font-mono-mm text-lg uppercase tracking-[0.35em] text-[#E0753B] md:mx-11 md:text-2xl">
                    Back Soon
                </span>
                <Horseshoe />
            </span>
        ))}
    </div>
);

export default function EditorialMarquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="relative z-10 overflow-hidden border-y border-white/10 bg-[#0B1612] py-6 md:py-8"
        >
            <motion.div
                className="flex w-max will-change-transform"
                animate={{ x: ["0%", "-50%"] }}
                transition={{ duration: 32, ease: "linear", repeat: Infinity }}
            >
                <Sequence />
                <Sequence hidden />
            </motion.div>
        </div>
    );
}
